import { render } from "./ManageSitterAndDuals.vue?vue&type=template&id=33564238"
import script from "./ManageSitterAndDuals.vue?vue&type=script&lang=js"
export * from "./ManageSitterAndDuals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/windowOverlay/ManageSitterAndDuals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33564238"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33564238', __exports__)) {
    api.reload('33564238', __exports__)
  }
  
  module.hot.accept("./ManageSitterAndDuals.vue?vue&type=template&id=33564238", () => {
    api.rerender('33564238', render)
  })

}


export default __exports__